import React from "react";


import { useDispatch } from "react-redux";
import { TwDropzone, TwFormHelperText } from "../../../components/tailwind";

export default function BusinessProfileImgInput({ setFieldValue, values, errors = {} }) {

  const dispatch = useDispatch();
  const [logo, setLogo] = React.useState(values.logo);
  const [coverPhoto, setCoverPhoto] = React.useState(values?.images && values?.images.length ? values?.images[0] : "");
  const [formErrors, setFormErrors] = React.useState({});

  React.useEffect(() => {
    // console.log("logo", logo);
    // console.log("coverPhoto", coverPhoto);
    setFieldValue("logo", logo);
    setFieldValue("coverPhoto", coverPhoto);
    setFieldValue("images", [coverPhoto]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logo, coverPhoto]);


  return (
    <div className={"flex flex-col place-items-start justify-start items-start md:max-w-lg"}>
      <div className={"my-3"}>
        <h6
          className={"text-xl sm:text-sm/6 md:text-base font-bold text-gray-500"}
        >
          Your Logo
          <span className={"text-base sm:text-sm md:text-sm text-center text-gray-400"}>
            (Optional)
          </span>
        </h6>
      </div>
      <TwDropzone
        // label={"Your Logo"}
        variant={"profile"}
        name={"logo"}
        value={values.logo}
        errors={formErrors}
        onChange={(image) => {
          console.log("image", image);
          setLogo(image);
        }}
      />
      {(errors["logo"] || errors["photo"]) && (
        <TwFormHelperText error={true}>{errors["logo"] || errors["photo"]}</TwFormHelperText>
      )}
    </div>
  );
}
